module.exports = __webpack_public_path__ + "img/Penny-Pinch-Artist.05595a32.png";